module.exports = __webpack_public_path__ + "img/abeja_agently_title.7d986983.png";